<template>
  <div class="w-full h-full flex">
    <!-- {{ question }} -->
    <button
      class="w-1/6 border-0 rounded-l-lg cursor-pointer"
      @mousedown="myTimeoutDecrementar"
      @mouseup="clearTimout"
      @mouseout="clearTimout"
    >
      <feather-icon icon="MinusIcon" svgClasses="w-5 h-5" />
    </button>
    <div ref="slider" class="h-full border w-full bg-white relative">
      <div ref="sliderLine" class="bg-primary h-full"></div>
      <span class="absolute inline-block w-full top-0 h-full flex items-center justify-center font-bold">{{
        counter
      }}</span>
    </div>
    <button
      class="w-1/6 border-0 rounded-r-lg cursor-pointer"
      @mousedown="myTimeoutAunmetar()"
      @mouseup="clearTimout"
      @mouseout="clearTimout"
    >
      <feather-icon icon="PlusIcon" svgClasses="w-5 h-5" />
    </button>
  </div>
</template>

<script>
export default {
  props: ["value", "question", "active"],
  mounted() {
    this.resize();
  },
  data() {
    return {
      counter: this.value || 0, //Se debe pasar
      slider: this.question.properties.maxValue, //Se debe pasar
      step: 0,
      width: 0,
      widthSlider: 0,
      polling: null
    };
  },
  watch: {
    active: function (value) {
      if (!value) {
        this.resize();
      }
    }
  },
  methods: {
    resize() {
      const line = this.$refs.sliderLine;
      const slider = this.$refs.slider;
      this.widthSlider = slider.offsetWidth;
      this.step = this.widthSlider / this.slider;

      if (this.counter === 0) line.style.width = "0px";
      else {
        const backgroundLine = this.step * this.counter;
        line.style.width = `${backgroundLine}px`;
      }
    },
    myTimeoutAunmetar() {
      this.polling = setInterval(this.aunemtar, 90);
    },
    myTimeoutDecrementar() {
      this.polling = setInterval(this.decrementar, 90);
    },
    clearTimout() {
      clearTimeout(this.polling);
    },
    aunemtar() {
      if (this.counter * this.step < this.widthSlider) {
        this.counter++;
        const line = this.$refs.sliderLine;
        this.width = this.step * this.counter;
        line.style.width = `${this.width}px`;
        this.$emit("input", String(this.counter));
      }
    },
    decrementar() {
      const line = this.$refs.sliderLine;
      if (this.counter * this.step >= this.step) {
        this.counter--;
        this.width = this.step * this.counter;
        line.style.width = `${this.width}px`;
        this.$emit("input", String(this.counter));
        return;
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
